import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=40ef83e8&scoped=true"
import script from "./Acciones.vue?vue&type=script&lang=js"
export * from "./Acciones.vue?vue&type=script&lang=js"
import style0 from "./Acciones.vue?vue&type=style&index=0&id=40ef83e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef83e8",
  null
  
)

export default component.exports